module.exports = __webpack_public_path__ + "img/trial_monitoring.b23c7bef.png";